import { MapPin, ArrowUpRight } from "lucide-react";
import { LOCATIONS, PROCESS_STEPS } from "@/content";
import { Reveal } from "@/components/landing/Reveal";

export const Process = () => (
  <section id="locations" data-testid="locations-section" className="relative scroll-mt-28 border-t border-white/10 py-24 sm:py-32">
    <div className="mx-auto max-w-7xl px-6">
      <Reveal>
        <p className="font-mono text-xs uppercase tracking-[0.35em] text-zinc-400">Where we serve</p>
        <h2 className="mt-4 max-w-3xl font-display text-2xl font-bold uppercase tracking-tight sm:text-4xl lg:text-5xl">
          Hometown: <span className="text-zinc-500">{LOCATIONS.hometown}.</span>
        </h2>
        <p className="mt-6 max-w-2xl text-sm leading-relaxed text-zinc-400 sm:text-base">
          {LOCATIONS.blurb}
        </p>
        <div className="mt-8 flex flex-wrap gap-2" data-testid="locations-countries">
          {LOCATIONS.countries.map((country) => (
            <span
              key={country}
              className="inline-flex items-center gap-2 rounded-full border border-white/10 px-4 py-1.5 text-xs text-zinc-300"
            >
              <MapPin className="h-3 w-3 text-zinc-500" />
              {country}
            </span>
          ))}
        </div>
      </Reveal>

      <div className="mt-24">
        <Reveal>
          <p className="font-mono text-xs uppercase tracking-[0.35em] text-zinc-400">How our service works</p>
        </Reveal>
        <div className="mt-8 divide-y divide-white/5 border-y border-white/10">
          {PROCESS_STEPS.map((step, i) => (
            <Reveal key={step.index} delay={i * 0.08}>
              <div
                data-testid={`process-step-${step.index}`}
                className="flex items-baseline gap-6 py-6 sm:gap-10"
              >
                <span className="shrink-0 font-mono text-xs tracking-[0.3em] text-zinc-500">
                  {step.index}
                </span>
                <p className="max-w-3xl text-sm leading-relaxed text-zinc-300 sm:text-base">
                  {step.text}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
        <Reveal delay={0.2}>
          <a
            href="/terms"
            data-testid="process-terms-link"
            className="mt-8 inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.2em] text-zinc-400 transition-colors duration-300 hover:text-white"
          >
            Read our full terms <ArrowUpRight className="h-4 w-4" />
          </a>
        </Reveal>
      </div>
    </div>
  </section>
);
